import React from "react";

export const CreditAuthorizationDisclaimer: React.FC = () => {
  return (
    <div 
      style={{ 
        marginBottom: "30px",
        backgroundColor: "var(--ucl-primary-light)",
        border: "1px solid var(--ucl-primary)",
        borderLeft: "4px solid var(--ucl-primary)",
        borderRadius: "var(--ucl-border-radius)",
        padding: "1rem 1.5rem",
        boxShadow: "0 1px 3px var(--ucl-shadow)"
      }}
    >
      <p style={{ fontSize: "16px", lineHeight: "1.6", color: "#333", margin: "0 0 16px 0" }}>
        To continue your application, we need your permission to obtain your credit report.
      </p>
      <p style={{ fontSize: "16px", lineHeight: "1.6", color: "#333", margin: "0 0 16px 0" }}>
        By proceeding, you authorize us to obtain your credit report and other relevant consumer and business reports from one or more credit bureaus (including Experian, Equifax, TransUnion, and others).
      </p>
      <p style={{ fontSize: "16px", lineHeight: "1.6", color: "#333", margin: "0" }}>
        You understand this is a hard credit inquiry, which may affect your credit score.
      </p>
    </div>
  );
};
